module.exports = __webpack_public_path__ + "img/hxm.47e034ad.jpg";